/* eslint-disable */
'use strict';
exports.__esModule = true;
exports.default = {
    "account": "Cuenta",
    "active_date": "Fecha activa",
    "address": "Dirección",
    "address2": "Dirección 2 (opcional)",
    "amount": "Monto",
    "and": "y",
    "article": "Artículo",
    "buy": "Compra",
    "buyer": "Comprador",
    "buyer_info": "Información del comprador",
    "cancel": "Cancelar",
    "canceled": "Cancelado",
    "cellphone": "Teléfono móvil",
    "certification_expires": "No autorizado o expirado, inicie sesión nuevamente",
    "change_password": "Cambiar contraseña",
    "city": "Ciudad",
    "clear": "Limpiar",
    "commercial": "Comercial",
    "company": "Empresa",
    "completed": "Completado",
    "confirm_password": "Confirmar Contraseña",
    "contact": "Contacto",
    "country": "País",
    "create": "Crear",
    "create_account": "Crear cuenta",
    "create_date": "Fecha de Creación",
    "creationdate": "Fecha de Creación",
    "currency": "Moneda",
    "customer_success": "Registro exitoso, revise su correo y complete la activación",
    "dead_line": "Fecha límite",
    "dealer": "Distribuidor",
    "dealer_success": "En espera de aprobación",
    "description": "Descripción",
    "domain": "Dominio",
    "domain_in_use": "El dominio ya está en uso",
    "email": "Correo electrónico",
    "email_format_error": "Formato de correo incorrecto",
    "email_used": "El correo ya está en uso",
    "enter_character": "Introduzca los caracteres de la imagen",
    "enter_confirm_password": "Introduzca nuevamente la nueva contraseña",
    "enter_new_password": "Introduzca la nueva contraseña",
    "enter_old_password": "Introduzca la contraseña antigua",
    "erp_list": "Suscripciones",
    "erp_status": "Estado",
    "expire_date": "Fecha de expiración",
    "female": "Femenino",
    "first_name": "Nombre",
    "forget_password": "¿Olvidó su contraseña?",
    "forgot_password": "¿Olvidó su contraseña?",
    "form_not_exist": "El formulario no existe",
    "format_error": "Error de Formato",
    "group_code": "Código de grupo",
    "group_name": "Nombre de Grupo",
    "home_company_address": "Dirección casa/empresa",
    "image": "Imagen",
    "information_success": "Modificación de la cuenta exitosa",
    "initial_info": "Información inicial",
    "input_password": "Introduzca la contraseña",
    "input_password_again": "enter_password_again:",
    "last_name": "Apellido",
    "legal_person": "Persona jurídica",
    "male": "male:",
    "modify": "Modificar",
    "modify_erp_information": "Modificar info ERP",
    "modules": "Módulos",
    "month": "Usuario/mes",
    "name": "Nombre",
    "new_password": "Nueva Contraseña",
    "new_password_toEmail": "Se ha enviado una nueva contraseña a su correo",
    "next": "Siguiente",
    "noFoundurl": "La instancia no existe",
    "not_null": "Hay campos obligatorios sin completar",
    "official_website": "Sitio web oficial:",
    "ok": "OK",
    "old_password": "Contraseña Anterior",
    "old_password_error": "La contraseña antigua no coincide",
    "one_time_payment": "Pago único",
    "operation": "Operación",
    "or": "O",
    "order": "Orden",
    "order-no": "N° pedido",
    "order_close": "El pedido ha sido cerrado",
    "order_list": "Lista de pedidos",
    "order_no": "Nº de Pedido",
    "order_status": "Estado del pedido",
    "other": "Otro",
    "paid": "Pagado",
    "password": "Contraseña",
    "password_error": "La contraseña debe tener 6-20 caracteres con letras y números",
    "password_error_two": "Las contraseñas no coinciden",
    "password_least": "La contraseña debe tener al menos 6 caracteres con números y letras/caracteres especiales",
    "password_strength": "Fortaleza de Contraseña",
    "pay": "Compra",
    "pay_error": "Error al obtener datos de pago",
    "payment": "Método de pago",
    "payment_date": "Fecha de Pago",
    "personal": "Personal",
    "please_email": "Revise su correo",
    "pos": "Pos",
    "previous": "Anterior",
    "price": "Precio",
    "privacy": "Al crear una cuenta SOMATIME, acepta",
    "privacy_notice": "Aviso de privacidad",
    "product": "Produtos",
    "product_list": "Lista de productos",
    "product_name": "Nombre del Producto",
    "purchase": "Compra",
    "purchase_success": "Compra exitosa",
    "refunded": "Reembolsado",
    "registered": "Este correo ya está registrado",
    "registered_email_address": "Nos hemos registrado con su correo",
    "renewal": "Renovación",
    "repeat_password": "Repetir contraseña",
    "requied": "Requerido",
    "requied_num": "Solo números",
    "require_tips": "Faltan datos del comprador",
    "required": "Requerido",
    "reseller": "Revendedor",
    "resend": "Reenviar",
    "reset_password": "Se ha enviado un correo con enlace de confirmación a",
    "revoke": "Cancelar pedido",
    "revoke_tip1": "¿Cerrar el pedido actual?",
    "role": "Rol",
    "search": "Buscar",
    "send_update": "Enviarme actualizaciones de SOMATIME",
    "sex": "Sexo",
    "signIn": "Iniciar Sesión",
    "sign_out": "Cerrar sesión",
    "state": "Estado/Provincia",
    "status": "Estado de pago",
    "status_not_match": "El estado no coincide",
    "strength_high": "Alto",
    "strength_low": "Bajo",
    "strength_mid": "Medio",
    "submit": "Enviar",
    "submitted": "Enviado",
    "subscribe": "Suscribirse",
    "subscribe-mon": "Suscripción-mensual",
    "subscript_success": "Suscripción exitosa",
    "telephone": "Teléfono",
    "tenant_list": "Lista de inquilinos",
    "tenant_management_system": "Sistema de gestión de inquilinos",
    "tenant_system": "Sistema de inquilinos",
    "terms_of_use": "Términos de uso",
    "time_info": "Información de tiempo",
    "title": "Título",
    "unpaid": "No Pagado",
    "update_password_success": "Contraseña modificada correctamente",
    "user": "Usuario",
    "user_check": "Lea y acepte la política de privacidad y términos de uso",
    "user_id": "ID de usuario",
    "user_month": "Mes",
    "user_not_active": "Usuario no activado",
    "user_not_exist": "El usuario no existe",
    "user_password_error": "Contraseña incorrecta",
    "user_qty": "Cantidad de usuarios",
    "username": "Nombre de usuario",
    "ver_code_error": "Código de verificación incorrecto",
    "ver_code_exd": "Código de verificación expirado",
    "visit": "Visitar",
    "welcome_to_iceq": "BIENVENIDO A SOMATIME",
    "zip": "Código postal",
    "trial": "Prueba",
    "requesting_a_trial": "Solicitud exitosa, recibirá info en 24 h",
    "trial_orders_have_been_requested": "Solicitud de prueba enviada",
    "apply_trial": "Solicitar demo",
    "request_": "Solicitud",
    "trial_": "Prueba",
    "on_trial": "En prueba",
    "order_not_exist": "El pedido no existe",
    "wait_for_payment": "Esperando pago",
    "trial_reject": "Demo rechazada",
    "tips": "Consejos",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "trial_only_allow_one_time_payment_method": "Prueba solo pago único",
    "domain_info": "Info de dominio",
    "please_fill_in_domain_info": "Complete info de dominio",
    "user_quantity_and_month_required": "Usuarios y meses requeridos",
    "password_must_be_the_same": "Confirmación debe coincidir",
    "enter_the_password_and_new_password": "Introduzca contraseña y nueva",
    "wrong_user_name_and_password": "Usuario/contraseña incorrectos",
    "close_the_page_without_saving": "¿Cerrar sin guardar?",
    "cancel_input": "Cancelar entrada",
    "user_does_not_exist": "Usuario no existe",
    "modify_success": "Modificado con éxito",
    "email_has_been_used": "Email ya en uso",
    "created_successfully": "Creado correctamente",
    "error_tip_10098": "Error envío, contacte admin",
};